module.exports = __webpack_public_path__ + "static/hasta-1000-d52cad01be0df334ada551de44408db9.jpg";